const e = "overlay", o = "overlay__header", a = "overlay__title", r = "overlay__container", _ = {
  overlay: e,
  "overlay--open": "overlay--open",
  "overlay__sticky-header": "overlay__sticky-header",
  overlay__header: o,
  overlay__title: a,
  overlay__container: r
};
export {
  _ as default,
  e as overlay,
  r as overlay__container,
  o as overlay__header,
  a as overlay__title
};
